export const ru = {
    popup_hint: 'Отсюда можно перейти к заявкам других участников командировки',
};
